import { Outlet, useLocation } from '@tanstack/react-router';
import { SidebarInset, SidebarProvider, SidebarTrigger } from '@ui/sidebar.tsx';
import { AdminSidebar } from '@admin/components/navigation/admin-sidebar.tsx';
import { FiddyAdminSidebar } from '@admin/components/navigation/fiddy-admin-sidebar.tsx';
import { HierarchySidebar } from '@admin/components/navigation/hierarchy-sidebar.tsx';
import { Separator } from '@ui/separator.tsx';
import AppBreadcrumb from '@admin/components/navigation/app-breadcrumb.tsx';
import { ChangelogLoginModal } from '@r/components/changelogs/changelog-login-modal.tsx';

const Layout = () => {
  const location = useLocation();

  const isFiddyAdminRoute = location.pathname.startsWith('/fiddy-admin');
  // Page canvas d'une hiérarchie précise uniquement, pas la liste des hiérarchies.
  const isHierarchyDetailRoute = /^\/settings\/hierarchy\/\d+$/.test(location.pathname);
  const SidebarComponent = isFiddyAdminRoute
    ? FiddyAdminSidebar
    : isHierarchyDetailRoute
      ? HierarchySidebar
      : AdminSidebar;

  return (
    <SidebarProvider className="items-start">
      <SidebarComponent />
      <SidebarInset
        className={
          isHierarchyDetailRoute
            ? 'relative h-svh overflow-hidden bg-body'
            : 'flex-grow overflow-auto bg-body'
        }
      >
        <header
          className={
            isHierarchyDetailRoute
              ? 'absolute inset-x-0 top-0 z-20 flex items-center gap-2 h-14 shrink-0'
              : 'flex items-center gap-2 h-14 shrink-0'
          }
        >
          <div className="flex items-center flex-1 gap-2 px-3">
            <SidebarTrigger />
            <Separator orientation="vertical" className="h-4 mr-2" />
            <AppBreadcrumb />
          </div>
        </header>
        <div
          className={
            isHierarchyDetailRoute
              ? 'absolute inset-0 overflow-hidden'
              : 'flex flex-col px-5 pb-10 grow'
          }
        >
          <Outlet />
        </div>
      </SidebarInset>

      <ChangelogLoginModal />
    </SidebarProvider>
  );
};

export default Layout;
